module.exports = __webpack_public_path__ + "img/symbols.3ab367e0.svg";